import { mapParamsBySchema } from '../../../util';
import { apiRequest } from '../../../Services/Common/ApiRequest';
import Global from '../../../Services/Common/Global';
import { M_DCM_BASIC_01_Schema } from './M_DCM_BASIC_01_Schema';
import useSearchMutation from '../../../Hooks/apis/useSearchMutaion';

/** 사업장 조회 GetCustManager (Global.urls.Utility.getCustManager) */
export const useSearch1 = (successOptions) => {
  return useSearchMutation((context) => {
    const params = mapParamsBySchema(M_DCM_BASIC_01_Schema.mapper.search1, context);
    return apiRequest('post', Global.urls.Utility.getCustManager, params);
  }, successOptions);
};

/** 부서 조회 GetDepLast (Global.urls.Utility.getDepLast) */
export const useSearch2 = (successOptions) => {
  return useSearchMutation((context) => {
    const params = mapParamsBySchema(M_DCM_BASIC_01_Schema.mapper.search2, context);
    return apiRequest('post', Global.urls.Utility.getDepLast, params);
  }, successOptions);
};

/** 탭 조회 GetTab (Global.urls.Utility.getTab) */
export const useSearch3 = (successOptions) => {
  return useSearchMutation((context) => {
    const params = mapParamsBySchema(M_DCM_BASIC_01_Schema.mapper.search3, context);
    return apiRequest('post', Global.urls.Utility.getTab, params);
  }, successOptions);
};
